import axios, { AxiosInstance } from "axios";
import ENV from "../config/env";
import keycloakInstance from "../config/keycloak";

class TMobileService {
  adm: AxiosInstance;
  constructor() {
    this.adm = axios.create({
      baseURL: ENV.TMOBILE_API,
    });
    this.adm.interceptors.request.use(
      async (config: any) => {
        config.headers["Content-Type"] = "application/json";
        config.headers["x-api-key"] = ENV.TMOBILE_API_KEY;
        config.headers["Secret"] = "Password";
        // config.headers["Authorization"] = "Bearer " + keycloakInstance?.token;
        return config;
      },
      (error) => {
        Promise.reject(error);
      }
    );
  }

  get(url: string) {
    const URL = url;
    return this.adm.get(URL);
  }
  post(url: string, params?: any) {
    return this.adm.post(url, params);
  }
}

export default new TMobileService();
